export default __webpack_public_path__ + "static/media/sort-active.4424087b.svg";